export class MPAReviewNotificationArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "requestId",
            "baseName": "requestId",
            "type": "string",
            "format": ""
        },
        {
            "name": "operation",
            "baseName": "operation",
            "type": "string",
            "format": ""
        },
        {
            "name": "requesterEmail",
            "baseName": "requesterEmail",
            "type": "string",
            "format": ""
        },
        {
            "name": "reviewerEmail",
            "baseName": "reviewerEmail",
            "type": "string",
            "format": ""
        },
        {
            "name": "decision",
            "baseName": "decision",
            "type": "string",
            "format": ""
        },
        {
            "name": "comment",
            "baseName": "comment",
            "type": "string",
            "format": ""
        },
        {
            "name": "newStatus",
            "baseName": "newStatus",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MPAReviewNotificationArguments.attributeTypeMap;
    }
    constructor() {
    }
}
